/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Linux_S1Inputs */

const en_wc_dl_linux_s1 = /** @type {(inputs: Wc_Dl_Linux_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AppImage (any distro): make it executable, then run it.`)
};

/**
* | output |
* | --- |
* | "AppImage (any distro): make it executable, then run it." |
*
* @param {Wc_Dl_Linux_S1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_linux_s1 = /** @type {((inputs?: Wc_Dl_Linux_S1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Linux_S1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_linux_s1(inputs)
});
export { wc_dl_linux_s1 as "wc.dl.linux.s1" }